import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslationModule } from '../shared/models/translation.module';
import { SharedModule } from '../shared/shared.module';
import { CreateProductComponent } from './create-product/create-product.component';
import { ManageProductComponent } from './manage-product/manage-product.component';
import { ProductComponent } from './product.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    
    SharedModule,
    TranslationModule,
  ],
  declarations: [
    ProductComponent,
    CreateProductComponent,
    ManageProductComponent,
  ],
  providers: [

  ]
})
export class ProductModule {

}
